import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import Tooltip, { TooltipTypography } from '@precis-digital/kurama/Tooltip';
import { formatNumberDifference, type FormatIds } from 'shared/numberFormat';
import PercentageTypography from 'shared/components/PercentageTypography';
import { formatDateToString } from 'shared/dateFns';
import { ExpandedNumberFormat } from 'shared/components/NumberFormat';
import { type CurrencyCodes } from 'shared/constants/currency';
interface BaseSummaryTooltipProps {
  children: React.ReactNode;
  presentValue: number;
  previousValue: number;
  previousTimePeriod?: [string, string];
  timePeriod?: [string, string];
  currencyCode: CurrencyCodes;
  id: FormatIds;
  title: string;
  reverseColorScheme?: boolean;
  previousValueHeaderText?: string;
  presentValueHeaderText?: string;
}
interface TimePeriodSummaryTooltipProps extends BaseSummaryTooltipProps {
  previousTimePeriod: [string, string];
  timePeriod: [string, string];
}
interface HeaderTextSummaryTooltipProps extends BaseSummaryTooltipProps {
  previousValueHeaderText: string;
  presentValueHeaderText: string;
}
const NumberSummaryTooltip = t0 => {
  const $ = _c(50);
  const {
    children,
    presentValue,
    previousValue,
    previousTimePeriod,
    timePeriod,
    currencyCode,
    id,
    title,
    reverseColorScheme,
    previousValueHeaderText,
    presentValueHeaderText
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <TooltipTypography variant="body3">{title}</TooltipTypography>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== presentValue || $[3] !== previousValue || $[4] !== reverseColorScheme) {
    t2 = <PercentageTypography presentValue={presentValue} previousValue={previousValue} reverseColorScheme={reverseColorScheme} />;
    $[2] = presentValue;
    $[3] = previousValue;
    $[4] = reverseColorScheme;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== currencyCode || $[7] !== id || $[8] !== presentValue || $[9] !== previousValue) {
    t3 = formatNumberDifference({
      presentValue,
      previousValue,
      id,
      currencyCode
    });
    $[6] = currencyCode;
    $[7] = id;
    $[8] = presentValue;
    $[9] = previousValue;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <TooltipTypography variant="body3">{t3}</TooltipTypography>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t4) {
    t5 = <Grid display="flex" alignItems="center" gap="4px">{t1}{t2}({t4})</Grid>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== presentValueHeaderText || $[18] !== timePeriod) {
    t6 = presentValueHeaderText ?? (timePeriod != null ? `${formatDateToString({
      date: timePeriod[0]
    })} - ${formatDateToString({
      date: timePeriod[1]
    })}` : "");
    $[17] = presentValueHeaderText;
    $[18] = timePeriod;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t6) {
    t7 = <TooltipTypography variant="body2">{t6}</TooltipTypography>;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== currencyCode || $[23] !== id || $[24] !== presentValue) {
    t8 = <ExpandedNumberFormat value={presentValue} id={id} currencyCode={currencyCode} />;
    $[22] = currencyCode;
    $[23] = id;
    $[24] = presentValue;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t7 || $[27] !== t8) {
    t9 = <Grid display="flex" justifyContent="space-between" alignItems="center" gap="8px">{t7}{t8}</Grid>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== previousTimePeriod || $[30] !== previousValueHeaderText) {
    t10 = previousValueHeaderText ?? (previousTimePeriod != null ? `${formatDateToString({
      date: previousTimePeriod[0]
    })} - ${formatDateToString({
      date: previousTimePeriod[1]
    })}` : "");
    $[29] = previousTimePeriod;
    $[30] = previousValueHeaderText;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10) {
    t11 = <TooltipTypography variant="body2">{t10}</TooltipTypography>;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== currencyCode || $[35] !== id || $[36] !== previousValue) {
    t12 = <ExpandedNumberFormat value={previousValue} id={id} currencyCode={currencyCode} />;
    $[34] = currencyCode;
    $[35] = id;
    $[36] = previousValue;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t11 || $[39] !== t12) {
    t13 = <Grid display="flex" justifyContent="space-between" alignItems="center" gap="8px">{t11}{t12}</Grid>;
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t13 || $[42] !== t9) {
    t14 = <Grid container={true} flexDirection="column">{t9}{t13}</Grid>;
    $[41] = t13;
    $[42] = t9;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== children) {
    t15 = <Grid>{children}</Grid>;
    $[44] = children;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t14 || $[47] !== t15 || $[48] !== t5) {
    t16 = <Tooltip kind="multiline" width="fit-content" title={t5} body={t14}>{t15}</Tooltip>;
    $[46] = t14;
    $[47] = t15;
    $[48] = t5;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  return t16;
};
export default NumberSummaryTooltip;